import { render, staticRenderFns } from "./PublishCampaignModal.vue?vue&type=template&id=8d170038&lang=pug"
import script from "./PublishCampaignModal.vue?vue&type=script&lang=js"
export * from "./PublishCampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports